import * as React from "react";
import { cn } from "@finster/ui";

interface ComposerModeToggleProps {
  enabled: boolean;
  onToggle: () => void;
  label: string;
  accentColorHex?: string;
}

export const ComposerModeToggle: React.FC<ComposerModeToggleProps> = ({
  enabled,
  onToggle,
  label,
  accentColorHex,
}) => (
  <button
    type="button"
    aria-pressed={enabled}
    aria-label={label}
    onClick={onToggle}
    style={
      enabled && accentColorHex
        ? {
            color: accentColorHex,
            backgroundColor: `${accentColorHex}14`,
            boxShadow: `inset 0 0 0 1px ${accentColorHex}33`,
          }
        : undefined
    }
    className={cn(
      "group inline-flex h-7 cursor-pointer items-center gap-2 rounded-lg px-2.5 text-[11px] transition-all",
      "focus:outline-none focus-visible:ring-2 focus-visible:ring-ring-focus focus-visible:ring-offset-2",
      enabled && !accentColorHex && "bg-primary/10 text-primary shadow-sm",
      enabled && accentColorHex && "shadow-sm",
      !enabled && "text-muted-foreground hover:bg-accent/60 hover:text-foreground"
    )}
  >
    <span
      className={cn(
        "relative inline-flex h-3.5 w-7 items-center rounded-full transition-colors",
        !enabled && "bg-muted-foreground/25",
        enabled && !accentColorHex && "bg-primary"
      )}
      style={enabled && accentColorHex ? { backgroundColor: accentColorHex } : undefined}
    >
      <span
        className={cn(
          "absolute h-2.5 w-2.5 rounded-full bg-white shadow-sm transition-transform",
          enabled ? "translate-x-3.5" : "translate-x-0.5"
        )}
      />
    </span>
    <span className="font-medium">{label}</span>
  </button>
);
